/**
 * Categories — Platform Admin страница мини-справочника «Товарные группы»
 * (таблица `reference.crop_categories`; переименован только UI-лейбл — код,
 * роут, имя таблицы и API остались прежними).
 * (AK-231 Pilot, FR-5). Тонкий wrapper над `ReferenceMiniCatalog`.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCategories,
  useCreateCategory,
  useDeleteCategory,
  useUpdateCategory,
} from './hooks/useReferenceQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return 'культур';
  if (mod10 === 1) return 'культура';
  if (mod10 >= 2 && mod10 <= 4) return 'культуры';
  return 'культур';
}

export function PlatformAdminCropCategoriesPage() {
  const q = useCategories();
  const createMut = useCreateCategory();
  const updateMut = useUpdateCategory();
  const deleteMut = useDeleteCategory();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Товарные группы"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить категорию"
        usageBadgeUnit={plural}
        guardMessage="Используется в культурах — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Категория создана');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Категория обновлена');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Категория удалена');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в select формы культуры.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminCropCategoriesPage;
